import styled from "styled-components";
import { Container } from "react-bootstrap";

export const CommentContainer = styled(Container)`
  box-shadow: var(--box-shadow1);
  border-radius: 6px;
  color: var(--blue-color-dark);
  img {
    object-fit: contain;
    border-radius: 6px;
  }
  figure {
    width: fit-content;
    figcaption {
      font-size: var(--font-size-xs);
      font-weight: 500;
      @media screen and (max-width: 992px) {
        font-size: var(--font-size-sm);
      }
    }
  }
`;

export const CommentHeaderContainer = styled.div`
  grid-template-columns: repeat(3, min-content);
  grid-column-gap: 0.5rem;
  align-items: center;
  svg {
    cursor: pointer;
    &:hover {
      color: var(--primary-color);
    }
  }
  @media screen and (max-width: 992px) {
    grid-template-columns: max-content auto auto;
  }
`;

export const CommentHeaderBadge = styled.span`
  width: 90px;
  text-align: center;
  background: var(--secondary-color);
  padding: 7px 10px;
  font-size: var(--font-size-xs);
  font-weight: 300;
  color: var(--text-color-dark);
  margin: 0 5px;
  border-radius: var(--border-radius-2);
  @media screen and (max-width: 992px) {
    justify-self: center;
  }
`;

export const CommentDetail = styled.div`
  padding: 5px;
  background: ${(props) => props?.isEditeMode && "var(--deactive-color)"};
  color: var(--blue-color-dark);
  border-radius: var(--border-radius-1);
  .title {
    font-weight: 500;
  }
  .text {
    font-size: var(--font-size-sm);
  }
  input,
  textarea,
  textarea:focus {
    background: transparent;
    display: block;
    border: none;
    color: var(--blue-color-dark);
    width: 100%;
  }
  textarea {
    resize: none;
    min-height: 100px;
  }
  button {
    height: initial;
    padding: 6px 18px;
    font-size: var(--font-size-xs);
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

export const CommentDate = styled.time`
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: var(--font-size-xs);
`;

export const StyledDeleteUserComment = styled.div`
  padding: 23px 0;
  
  button {
    padding: 4px 38px;
    border-radius: 18px;
    background: transparent;
    transition: all ease 0.3s;
    &:hover {
      color: var(--white-color);
      background: var(--primary-color);
      opacity: 0.8;
    }
  }
`;
